<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-user-alt"></i>
        탈퇴
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">관리</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">관리자</a>
        </li>
      </ul>
    </div>
    <b-card>
      <div class="d-flex flex-wrap align-items-center">
        <div class="title mr-auto">
          탈퇴 정보
        </div>
        <span class="float-right">요청일 : {{model.created_at | sdate}}</span>
      </div>
      <hr>
      <div class="row mb-2">
        <div class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_company">
            파트너
          </label>
        </div>
        <div class="col-xl-4 col-md-12  d-flex align-self-center">
          <h5>
            <a style="cursor:pointer;color:skyblue;" id="ph_company" v-if="model.partner" @click="$router.push({ name : 'partner', params : { id : model.partner.id } })">
              {{model.partner.username}}
            </a>
          </h5>
        </div>
        <div class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_groupname">
            그룹
          </label>
        </div>
        <div class="col-xl-4 col-md-12 d-flex align-self-center">
          <h5>
            <a style="cursor:pointer;color:skyblue;" id="ph_groupname" v-if="model.group" @click="$router.push({ name : 'group', params : { id : model.group.id } })">
              {{model.group.groupname}}
            </a>
          </h5>
        </div>
      </div>
      <div class="row mb-2 mt-3">
        <div class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_credit">
            신용 거래
          </label>
        </div>
        <div class="col-xl-4 col-md-12  d-flex align-self-center">
          <b-form-input type="text" v-if="model.group && lock" :value="model.group.credit" plaintext></b-form-input>
          <!-- <b-form-input v-if="model.group" type="text" id="ph_credit" :plantext="true"  v-model="model.group.credit" :disabled="lock"></b-form-input> -->
        </div>
        <div class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_service">
            서비스
          </label>
        </div>
        <div class="col-xl-4 col-md-12 align-self-center">
          <b-badge  v-if="model.group && lock" :variant="model.group.service == 'Basic' ? 'info' : 'success'">{{model.group.service}}</b-badge>
          <!-- <b-form-input v-if="model.group" type="text" id="ph_service" :plantext="true"  v-model="model.group.service" :disabled="lock"></b-form-input> -->
        </div>
      </div>
      <div class="row mb-2 mt-3">
        <div class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" abel-for="ph_use" v-b-tooltip.hover title="탈퇴 진행 유무">
            탈퇴 승인
          </label>
        </div>
        <div class="col-xl-4 col-md-12 align-self-center">
          <b-badge :variant="model.is_approve ? 'success' : 'secondary'">{{ model.is_approve ? '완료' : '대기'}}</b-badge>
        </div>
        <div class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" label-for="ph_use" v-b-tooltip.hover title="사용을 위한 복구 설정">
            복구
          </label>
        </div>
        <div class="col-xl-4 col-md-12 d-flex align-self-center">
          <div class="checkbox-switch">
            <input type="checkbox" class="input-checkbox" name="Allow_login" id="Allow_login" v-model="model.is_recovery" :disabled="lock">
            <div class="checkbox-animate disabled">
              <span class="checkbox-off">OFF</span>
              <span class="checkbox-on">ON</span>
            </div>
          </div>
          <span v-if="model.is_recovery" class="pl-3 mt-1">({{model.recovery_at | datetime}})</span>
        </div>
      </div>
      <div class="row mb-2 mt-3">
        <div class="col-xl-2 col-md-12 d-flex align-self-center" v-if="model.is_approve">
          <label class="col-form-label" lfor="ph_company">
            최근 사용 날짜
          </label>
        </div>
        <div class="col-xl-4 col-md-12  d-flex align-self-center" v-if="model.is_approve">
          <b-form-input type="text" id="ph_company" v-model="model.prev_bill_start_at" :plaintext="lock"></b-form-input>
            ~
          <b-form-input type="text" id="ph_company" v-model="model.prev_bill_end_at" :plaintext="lock"></b-form-input>
        </div>
        <div class="col-xl-2 col-md-12 d-flex align-self-center" v-if="model.is_approve">
          <label class="col-form-label" for="ph_description">
            설명
          </label>
        </div>
        <div class="col-xl-4 col-md-12" v-if="model.is_approve">
          <b-form-input type="text" v-if="lock" :value="model.description" plaintext></b-form-input>
          <!-- <b-form-input class="bg-light" type="text" id="ph_description" :disabled="model.is_del" v-model="model.description"></b-form-input> -->
        </div>
      </div>
      <div class="mb-2 mt-5">
        <b-button :disabled="model.is_del" size="sm" variant="success" @click="confirm_continue = true"> 재사용을 위한 복구(계속) </b-button>
        <b-button :disabled="model.is_del" size="sm" variant="danger" @click="confirm_end = true"> 서비스 종료 </b-button>
        <b-button size="sm" class="float-right" variant="primary" @click="list"> 목록 </b-button>
      </div>
    </b-card>
    <b-modal title="서비스 사용"  class="modal-warning" v-model="confirm_continue" @ok="service_continue" ok-variant="warning">
      서비스를 계속 사용하시겠습니까?
      오늘부터 다시 사용할 수 있습니다
    </b-modal>
    <b-modal title="서비스 종료"  class="modal-danger" v-model="confirm_end" @ok="service_end" ok-variant="danger">
      서비스를 종료하시겠습니까?
      데이터를 삭제할 수 있지만 복구할 수 없습니다.
    </b-modal>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>